import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useState, SyntheticEvent } from 'react';
import { useHelpModalState } from 'react-commons';
import { useStyles, useSetFlow } from '../../Shared';
import { Props } from '../CommercialSize';
import { useGlobalState } from '../../../state/persistence';

const useCommercialSize = ({ flow, nextUrl }: Props) => {
  const { t } = useTranslation('commercial_size');
  const history = useHistory();
  const { dispatchQuestion } = useGlobalState();
  const { toggleHelpModal } = useHelpModalState();

  const [size, setSize] = useState<number>(30);

  useSetFlow(flow);

  const onSizeChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setSize(Number(target.value));
  };

  const onSubmit = () => {
    dispatchQuestion('apartmentSize', size);

    if (nextUrl) {
      history.push(Array.isArray(nextUrl) ? nextUrl[0] : nextUrl);
    }
  };

  const onSkip = () => {
    dispatchQuestion('apartmentSize', '');

    if (nextUrl) {
      window.location.href = Array.isArray(nextUrl) ? nextUrl[1]! : nextUrl;
    }
  };

  const onChange = (e: any, value: number) => {
    setSize(Number(value));
  };

  return {
    classes: useStyles(),
    t,
    toggleHelpModal,
    onSubmit,
    onSkip,
    size,
    onSizeChange,
    onChange,
  };
};

export default useCommercialSize;
